import { type BrowserNavigatePath, JourneyRoute } from '@cash-web/shared-journey-util-main'

const PLAIN_ROUTE_PARAMETERS = ['content_token', 'origin'] as const
const HERO_ROUTE_PARAMETERS = ['content_token', 'hero_scene_slug', 'hero_scene_inputs', 'origin'] as const

const accountSpaceUrl = (requestUrl: string, parameterNames: readonly string[]): BrowserNavigatePath => {
  const url = new URL(requestUrl)
  const missingParameters = parameterNames.filter(name => !url.searchParams.get(name)?.trim())

  if (missingParameters.length > 0) {
    throw new Error(`Space: Missing required parameters: ${missingParameters.join(', ')}`)
  }

  const searchParams = new URLSearchParams()
  for (const name of parameterNames) {
    searchParams.set(name, url.searchParams.get(name) ?? '')
  }

  return `/account/space?${searchParams.toString()}`
}

export const spaceClientRoutes = [
  {
    id: 'space',
    trackingName: 'View Space',
    path: 'dl/frontdoor/space',
    loader: async ({ context, request }) => {
      context?.browserNavigate(accountSpaceUrl(request.url, PLAIN_ROUTE_PARAMETERS))
    },
  },
  {
    id: 'space-with-hero',
    trackingName: 'View Space With Hero',
    path: 'dl/frontdoor/space-with-hero',
    loader: async ({ context, request }) => {
      context?.browserNavigate(accountSpaceUrl(request.url, HERO_ROUTE_PARAMETERS))
    },
  },
] as const satisfies JourneyRoute[]
